<div class="upload-container">
  <div class="form-card">
    <ng-container *ngIf="validationMessageList?.length">
      <ul class="message-list success-list">
        <li
          class="message"
          *ngFor="let successMessage of validationMessageList"
        >
          <ng-container *ngIf="successMessage.extensionIcon">
            <mat-icon class="icon-align" fontSet="material-icons-outlined">{{
              successMessage.extensionIcon
            }}</mat-icon>
          </ng-container>
          <span>
            {{ successMessage.message }}
          </span>
        </li>
      </ul>
    </ng-container>
    <ng-container
      *ngIf="
        fileListFormControl?.value &&
        fileListFormControl?.errors &&
        !fileListFormControl?.errors.isRequired
      "
    >
      <ul class="message-list error-list">
        <li
          class="message"
          *ngFor="
            let errorMessage of fileListFormControl.errors | keyvalue;
            trackBy: 'key' | trackByKey
          "
        >
          <mat-icon class="icon-align" fontSet="material-icons-outlined"
            >error</mat-icon
          >
          <span>
            {{ errorMessage.value }}
          </span>
        </li>
      </ul>
    </ng-container>
    <form enctype="multipart/form-data" class="form-content" [formGroup]="form">
      <ng-container *ngIf="currentImageFile; else uploadBox">
        <div
          class="drop-container"
          appDragDropFiles
          (emitDropFileList)="onFileSelect($event)"
        >
          <div class="image-preview">
            <span class="accent-text"> Current File </span>
            <img [src]="currentImageFile" alt="Current file preview" />
          </div>
          Drag file<ng-container *ngIf="fileConfig?.canUploadMultiple"
            >s</ng-container
          >
          to upload
        </div>
      </ng-container>
      <!-- <ng-container *ngIf="imageUrl; else uploadBox">
        <div class="image-preview">
          <ng-container *ngIf="currentImageFile">
            <span class="accent-text"> New File </span>
          </ng-container>
          <img [src]="imageUrl" alt="Image Preview" />
        </div>
      </ng-container> -->
      <ng-template #uploadBox>
        <div
          class="drop-container"
          appDragDropFiles
          (emitDropFileList)="onFileSelect($event)"
        >
          <mat-icon
            class="drop-icon"
            color="primary"
            fontSet="material-icons-outlined"
            aria-label="Upload"
            >file_upload</mat-icon
          >
          Drag file<ng-container *ngIf="fileConfig?.canUploadMultiple"
            >s</ng-container
          >
          to upload
        </div>
      </ng-template>
      <div class="browse-container button-row-container">
        <ng-container *ngIf="imageUrl">
          <button
            class="primary-muted-button"
            mat-button
            (click)="onFileClear()"
          >
            <mat-icon
              color="primary"
              fontSet="material-icons-outlined"
              matTooltip="Reset"
              aria-label="Reset"
              aria-hidden="false"
              >delete</mat-icon
            >
          </button>
        </ng-container>
        <div>
          <!-- Reset input value so that the change event works with the image files reset button -->
          <!-- TODO: (change)="onFileSelect($event.target.files); input-value = ''" helps reset the input element so it will allow the user to select the same image after clearing it, but it prevents Files from being added to the form correctly. Figure out how to get both. -->
          <input
            type="file"
            #input
            [name]="fileId"
            [id]="fileId"
            title="File Uploader"
            [multiple]="fileConfig.canUploadMultiple"
            style="display: none"
            [accept]="fileConfig.allowedMimeTypeList.join(',')"
            (change)="onFileSelect($event.target.files)"
            [disabled]="disabled"
            [required]="required"
          />
          <!-- This is a label instead of a button so we can hide the input, style the label, and keep it accessible:
          https://www.benmarshall.me/styling-file-inputs/ -->
          <label
            [for]="fileId"
            class="primary-button file-label header-text"
            [ngClass]="{ 'primary-button-disabled': disabled }"
            matRipple
          >
            {{ 'Browse' | uppercase }}
          </label>
        </div>
      </div>
    </form>
    <ng-container *ngIf="isUploading$ | async">
      <mat-progress-bar
        mode="determinate"
        [value]="fileProgress$ | async"
      ></mat-progress-bar>
    </ng-container>
  </div>
</div>
